import { render, staticRenderFns } from "./DetailInfo.vue?vue&type=template&id=52e1e1f0&scoped=true&"
import script from "./DetailInfo.vue?vue&type=script&lang=js&"
export * from "./DetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./DetailInfo.vue?vue&type=style&index=0&id=52e1e1f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e1e1f0",
  null
  
)

export default component.exports